module.exports = __webpack_public_path__ + "img/dark-bg.3cdf353c.png";